import type { ComponentRegistry } from '@vibesites/runtime';
import {
  Header,
  Hero,
  WhiteBlock,
  PropertyOverview,
  SpecialOffers,
  CTASection,
  TabbedCallouts,
  FloorplansList,
  AmenitiesList,
  HomeAmenities,
  GalleryStaggered,
  NeighborhoodMap,
  VirtualTourEmbed,
  ContactForm,
  ContactBlock,
  TourBlock,
  ContactMap,
  ScheduleTourForm,
  Fees,
  PetPolicy,
  PageHero,
  PageBlurb,
  HeroSolidBG,
  Reviews,
  ReviewsCallout,
  HomeNeighborhood,
  SocialFollow,
  SpecialOfferBanner,
  ResidentAccess,
  AccessibilityStatement,
  PrivacyPolicyContent,
  SitemapContent,
  HyperlocalHero,
  HyperlocalPageCopy,
  ThankYouContent,
  FutureResidentsClub,
  ApartmentSyncSection,
  Footer,
  Navigation,
  InteractiveMapSection,
} from './components';

export const registry: ComponentRegistry = {
  Header,
  Hero,
  WhiteBlock,
  PropertyOverview,
  SpecialOffers,
  CTASection,
  TabbedCallouts,
  FloorplansList,
  AmenitiesList,
  HomeAmenities,
  GalleryStaggered,
  NeighborhoodMap,
  VirtualTourEmbed,
  ContactForm,
  ContactBlock,
  TourBlock,
  ContactMap,
  ScheduleTourForm,
  Fees,
  PetPolicy,
  PageHero,
  PageBlurb,
  HeroSolidBG,
  Reviews,
  ReviewsCallout,
  HomeNeighborhood,
  SocialFollow,
  SpecialOfferBanner,
  ResidentAccess,
  AccessibilityStatement,
  PrivacyPolicyContent,
  SitemapContent,
  HyperlocalHero,
  HyperlocalPageCopy,
  ThankYouContent,
  FutureResidentsClub,
  ApartmentSyncSection,
  Footer,
  Navigation,
  InteractiveMapSection,
};

export default registry;
